module.exports = __webpack_public_path__ + "img/logo.4544b4d7.png";